/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-31 14:01:30
 * @LastEditTime: 2021-06-25 13:50:54
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ViewUI from 'view-design';
import store from './store'
import Print from 'vue-print-nb'
import 'view-design/dist/styles/iview.css';
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'

const IS_PROD = ['production', 'prod'].includes(process.env.NODE_ENV)

Vue.config.productionTip = false
Vue.use(ViewUI);
Vue.use(Print);
let baseURL = "";
if (process.env.NODE_ENV === "production" && process.env.type === "analyz") {
  // baseURL = "";
} else if (IS_PROD) {
  baseURL = "//zidaiot.com/base";
  // baseURL = "//192.168.4.56:9000/base";
} else {
  baseURL = "//localhost:9000/base";
}
const token = localStorage.getItem("token");

Vue.use(new VueSocketIO({
  debug: false,
  connection: SocketIO(baseURL + '?token=' + token),
  reconnect: true,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_'
  }
}))


let vueThis = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vueThis